// extracted by mini-css-extract-plugin
module.exports = {"root":"MenuLabel_root__2JiKM","clickedWithMouse":"MenuLabel_clickedWithMouse__2ejKL","isOpen":"MenuLabel_isOpen__fJ9kB"};